import useCarGurusAd from 'lib/hooks/useCarGurusAd';
import CGAdConfig from 'types/CarGurusAdConfig';

export const CarGurusElementId = 'cg-pixel-ad';

export default function PixelAd({ targeting }: CGAdConfig): JSX.Element {
  useCarGurusAd({ targeting });

  return (
    <div className="cg-pixel-ad" id={`${CarGurusElementId}`}>
      <style jsx>{`
        .cg-pixel-ad {
          width: 1px;
          height: 1px;
        }
      `}</style>
    </div>
  );
}
